import { Component } from '@angular/core';
import { module } from "../../equipment-registration.module";
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EquipRegistrationServices } from '../../services/equipment-registration.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-equipment-registration-page',
  templateUrl: './equipment-registration.page.html',
  standalone: true,
  imports: module,
  styleUrls: ['./equipment-registration.page.scss']
})

export class EquipmentRegistrationPage {
  tabs: any[] = [
    {
      name: "General",
      route: "general",
    },
    {
      name: "XMAS TREE",
      route: "xmastree",
    },
    // {
    //   name: "CV",
    //   route: "cv",
    // },
    // {
    //   name: "LMV",
    //   route: "lmv",
    // },
    // {
    //   name: "KWV",
    //   route: "kwv",
    // },
    // {
    //   name: "WV",
    //   route: "wgv",
    // },
    // {
    //   name: "SSV",
    //   route: "ssv",
    // },
    {
      name: "CV",
      route: "cv",
    },
    {
      name: "LMV",
      route: "lmv",
    },
    {
      name: "KWV",
      route: "kwv",
    },
    {
      name: "WV",
      route: "wgv",
    },
    {
      name: "SSV",
      route: "ssv",
    },
    {
      name: "Annulus Valve A",
      route: "annulus-valve-a",
    },
    {
      name: "Annulus Valve B",
      route: "annulus-valve-b",
    },
    {
      name: "Annulus Valve C",
      route: "annulus-valve-c",
    },
    {
      name: "Annulus Valve D",
      route: "annulus-valve-d",
    },
    {
      name: "TRSCSSV /<br>Retrievable Valve / Plug",
      route: "trscssv-wrsv",
    },
  ];

  selectedTab = this.tabs[0];

  selectedWellString: boolean = false;
  searchForm: UntypedFormGroup;

  private sub = new Subscription();

  constructor(
    public router: Router,
    private _formBuilder: UntypedFormBuilder,
    private equipRegservices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    console.log(this.router.url.split('/')[4])
    this.setSearch();
    this.setSelectedTab()

    // view Equipment from general tab
    this.viewEquipmentSubscriber()
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  setSearch() {
    this.searchForm = this._formBuilder.group({
      Page: [0],
      PageSize: [5],
      OrderBy: [null],
      OrderDir: [null],
      WellName: [''],
      PlatformName: [''],
      StringName: [''],
      FieldName: [''],
    });

    this.searchForm.get('StringName').valueChanges.subscribe()
  }

  setSelectedTab() {
    const urlSegments = this.router.url.split('/');
    let lastSegment = urlSegments[urlSegments.length - 1];

    if (!lastSegment) return
    if (lastSegment == 'trscssv' || lastSegment == 'wrsv') lastSegment = 'trscssv-wrsv/trscssv'

    this.selectedTab = this.tabs.find(tab => tab.route == lastSegment)
  }

  viewEquipmentSubscriber() {
    this.sub.add(
      this.equipRegservices.viewEquipment$.subscribe((equipmentReg) => {
        if (!equipmentReg) return
        this.selectedTab = this.tabs.find(tab => tab.route == equipmentReg)

        const route = `/data-management/eReg/equipment-registration/${equipmentReg}`;
        this.router.navigate([route]);
      })
    );
  }

  onSelectedString(event) {
    this.selectedWellString = true;
    this.equipRegservices.getEquipmentRegistration(event.id).subscribe()
  }

  onToggleChange(e: MatButtonToggleChange) {
    this.selectedTab = e.value;
    let route = `/data-management/eReg/equipment-registration/${this.selectedTab.route}`;
    this.router.navigate([route]);
  }

  onSelectedTab(selectedTab) {
    if (selectedTab == 'trscssv-wrsv') {
      selectedTab = 'trscssv-wrsv/trscssv'
    }

    let route = `/data-management/eReg/equipment-registration/${selectedTab}`;
    this.router.navigate([route]);
  }

  onSelectedTabChange(event: any) {
    let selectedTab = this.tabs[event.index]
    if (!selectedTab) return

    const route = `/data-management/eReg/equipment-registration/${selectedTab.route}`;
    this.router.navigate([route]);
  }

  formatTabName(name: string) {
  return name.replace(/<br> /g, '<br>');
}
}
